import { StateCreator } from 'zustand'

import { FilterStore, OptionsSlice } from './types'

export const createOptionsSlice: StateCreator<FilterStore, [], [], OptionsSlice> = (set) => ({
  options: {
    ready: false,
    orgs: [],
    buildingsByOrgId: {},
    isCentralWarehouse: false,
    // ADD HERE
  },
  loading: {
    orgs: false,
    buildings: false,
    // ADD HERE
  },

  setOptions(values) {
    set((state) => ({
      options: {
        ...state.options,
        ...values,
      },
    }))
  },

  setLoading(key, value) {
    set((state) => ({
      loading: {
        ...state.loading,
        [key]: value,
      },
    }))
  },

  setReady(value) {
    set((state) => ({
      options: {
        ...state.options,
        ready: value,
      },
    }))
  },
})
